module.exports = __webpack_public_path__ + "img/trial4-2.a35423ca.png";